/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Header from 'parts/Header';
import Hero from 'parts/Hero';
import Advantage from 'parts/Advantage';
// import Portfolio from 'parts/Portfolio';  // Commented out
// import Testimonial from 'parts/Testimonial'; // Commented out
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';

export default class LandingPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <Hero />
         {/* <Service data={Services} />  // Commented out */}
        <Advantage />
        {/* <Portfolio data={Portfolios} />  // Commented out */}
        {/* <Testimonial data={Testimonials} />  // Commented out */}
        <Discuss />
        <Footer />
      </>
    );
  }
}
